import { useCallback } from 'react'

import { useDispatch } from 'react-redux'

import { CollectionUUID } from '@library/menu-service'

import {
  selectCollection,
  SelectCollectionCallback,
} from 'actions/menu-collections/selectCollection'

export const useSelectCollection = () => {
  const dispatch = useDispatch()

  return useCallback(
    (id: CollectionUUID, callback: SelectCollectionCallback = () => {}) => {
      dispatch(selectCollection(id, callback))
    },
    [dispatch],
  )
}
